import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { apiConstant } from '../app.constant';
import { PostTimesheetComment, Comments } from '../app.model';

@Injectable({
  providedIn: 'root'
})
export class CommentsService {

  constructor(
    private http: HttpClient
  ) { }

  getComments(parent_uuid: string, endPoint: string, parentKey: string) {
    return this.http.get<Comments>(`${environment.baseUrl + endPoint}?${parentKey}=${parent_uuid}`);
  }

  postComment(payload: PostTimesheetComment, endPoint: string) {
    return this.http.post<Comments>(`${environment.baseUrl}` + endPoint, payload);
  }
}
